const docTypeMap = [
{ docType: 'brokerPV', apiDocName: 'Broker PV' },
{ docType: 'estimate', apiDocName: 'Estimate' },
{ docType: 'euro_acc_statement', apiDocName: 'European Accident Statement' },
{ docType: 'invoice', apiDocName: 'Invoice' },
{ docType: 'orderForm', apiDocName: 'Order Form' },
{ docType: 'other', apiDocName: 'Other' },
{ docType: 'photo', apiDocName: 'Photo' },
{ docType: 'police_report', apiDocName: 'Police Report' },
{ docType: 'purchaseInvoice', apiDocName: 'Purchase invoice' },
{ docType:'purchaseInvoiceBikeLock', apiDocName: 'Purchase invoice of the bike lock'},
{ docType:'pictureofthecoveredobject', apiDocName: 'Picture of the covered object'},
{ docType: 'statement', apiDocName: 'Statement' },
{ docType: 'video', apiDocName: 'Video' }
]

function docNameApiLayerMapping(documentType) {
    const foundType = docTypeMap.find((portalType) => {
        return (portalType.docType === documentType);
    });

    if (foundType) {
        return foundType.apiDocName;
    }

    // if not found - that means error
    throw new Error(`No mapping found for document ${documentType}`);
}

export default docNameApiLayerMapping;
